<router-outlet #routeOutlet>
    <div *ngIf="loading">
        <i class="fa fa-fw fa-spin fa-refresh"></i>
        Loading...
    </div>
</router-outlet>
